module.exports = __webpack_public_path__ + "media/images/pr8-4ed4c3f6bfa23db426eeb713f8261109.png";